import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import getOutputFilesFromStep from 'analysis-tool/data/getOutputFilesFromStep';
import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as logging from 'util/Logging';

import {AnalysisMainViewItem, AnalysisMainViewItemType} from './main-view/MainViewTypes';
import getStepSidebarItemDatas from './sidebar/legacy-sidebar/getStepSidebarItemDatas';

/** Get a default main view item for a step.
 *
 * For now, returns the main view item associated with the first sidebar item related to the step.
 *
 * @deprecated
 */
export default function getDefaultMainViewItemForStep(step: GetAnalysisPipelineStep): AnalysisMainViewItem {
  const sidebarItemDatas = getStepSidebarItemDatas(step);
  const isMainViewItemExpected = step.statusCode !== PipelineStepStatusCode.BLOCKED;
  if (sidebarItemDatas.length === 0) {
    if (isMainViewItemExpected) {
      logging.warn('Unexpectedly found a step with 0 sidebar items', {
        extra: {
          numOutputFiles: getOutputFilesFromStep(step).length,
          stepId: step.id,
          stepStatusCode: step.statusCode,
          stepType: step.definition.stepType,
        },
      });
    }

    return {type: AnalysisMainViewItemType.EMPTY_ANALYSIS};
  }
  return sidebarItemDatas[0].mainViewItem;
}
